import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { Intake, PostDispatch, ProjectTimeline } from '../types';
import { transformDateFormat } from 'susy-common/date-utils';
import { ProjectTimelinesActionType } from '../actionTypes/projectTimelines';

export const getAllProjectTimeline =
    () => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/projectTimeline`);
        dispatch({
            type: ProjectTimelinesActionType.GET_ALL_PROJECT_TIMELINE,
            payload: transformDateFormat(response.data),
        });
    };

export const createProjectTimeline =
    (projectTimeline: ProjectTimeline) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.post(
            `/projectTimeline`,
            projectTimeline,
        );
        dispatch({
            type: ProjectTimelinesActionType.CREATE_PROJECT_TIMELINE,
            payload: response.data,
        });
    };

export const updateProjectTimeline =
    (projectTimeline: ProjectTimeline) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(`/projectTimeline`, projectTimeline);
        dispatch({
            type: ProjectTimelinesActionType.UPDATE_PROJECT_TIMELINE,
            payload: response.data,
        });
    };

export const updateProjectTimelineInUse =
    (projectTimeline: ProjectTimeline) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.put(
            `/projectTimeline/updateProjectTimelineInUse`,
            projectTimeline,
        );

        dispatch({
            type: ProjectTimelinesActionType.UPDATE_PROJECT_TIMELINE,
            payload: response.data,
        });
    };

export const getTimelinesByUserId =
    (userId: string) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.get(`/projectTimeline/user/${userId}`);
        dispatch({
            type: ProjectTimelinesActionType.GET_TIMELINES_BY_USERID,
            payload: transformDateFormat(response.data),
        });
    };

export const deleteTimeline =
    (timelineId: string) => async (dispatch: Dispatch<PostDispatch>) => {
        const response = await SuSyApi.delete(`/projectTimeline/${timelineId}`);
        dispatch({
            type: ProjectTimelinesActionType.DELETE_PROJECT_TIMELINE,
            payload: [response.data],
        });
    };
